// automatically generated by the FlatBuffers compiler, do not modify
export var ColumnType;
(function (ColumnType) {
    ColumnType[ColumnType["Byte"] = 0] = "Byte";
    ColumnType[ColumnType["UByte"] = 1] = "UByte";
    ColumnType[ColumnType["Bool"] = 2] = "Bool";
    ColumnType[ColumnType["Short"] = 3] = "Short";
    ColumnType[ColumnType["UShort"] = 4] = "UShort";
    ColumnType[ColumnType["Int"] = 5] = "Int";
    ColumnType[ColumnType["UInt"] = 6] = "UInt";
    ColumnType[ColumnType["Long"] = 7] = "Long";
    ColumnType[ColumnType["ULong"] = 8] = "ULong";
    ColumnType[ColumnType["Float"] = 9] = "Float";
    ColumnType[ColumnType["Double"] = 10] = "Double";
    ColumnType[ColumnType["String"] = 11] = "String";
    ColumnType[ColumnType["Json"] = 12] = "Json";
    ColumnType[ColumnType["DateTime"] = 13] = "DateTime";
    ColumnType[ColumnType["Binary"] = 14] = "Binary";
})(ColumnType || (ColumnType = {}));
